import { Container, Row, Col } from 'react-bootstrap';
import Breadcrumbs from '../../../../ntisui/Atoms/Breadcrumb';
import { hyperLinks } from '../../../../../constants/Constants';
import { breadcrumbsLinks } from '../../../../../constants/Constants';

const privacyNotice = () => {
  return (
    <Container className="main-container p-0">
      <Row>
        <Col xs={12} md={8}>
          <Breadcrumbs links={breadcrumbsLinks.privacyNotice} />
          <h3 className="main-heading" data-testid="privacy-notice">
            Privacy Notice
          </h3>
          <div className="main-content">
            <p>
              This privacy statement only covers the Traffic England web site.
              Links within this site to other web sites are not covered by this
              statement.
            </p>
            <h3>What information do we collect?</h3>
            <p>
              We store your email address, chosen password and a username you
              wish to be referred to by along with your saved settings and
              views. We may also store a cookie (if enabled by you) to make
              logging into our web site easier for you.{' '}
            </p>
            <p>
              Cookies are small text files that are placed on your computer by
              web sites that you visit. They cannot be used to identify you
              personally. They are widely used in order to improve web sites as
              well as to provide information to the owners of the site. Traffic
              England only uses cookies to improve services for you by storing
              and retrieving values as you navigate the site and recognising
              that you may already have given a username and password so you
              don't need to provide it for every visit. You can manage these
              small files yourself and learn more about them through "Internet
              browser cookies - what they are and how to manage them".
            </p>
            <h3>What do we do with the information we collect?</h3>
            <p>
              We use this to store your preferences and saved settings and to
              make logging into our web site easier for you. The information is
              stored on a server at the National Traffic Operations Centre and
              will be retained for the life of the web site.
            </p>
            <h3>Who do we share this information with?</h3>
            <p>
              The information we store is not shared with anyone and will not be
              used for any other purpose. If you want to know whether any
              information is held about you, please see our policy under the{' '}
              <a href={hyperLinks.privacyNoticeLink} target="_blank">
                General Data Protection Regulations and the Data Protection Act
                2018.
              </a>
            </p>
            <h3>Electronic Surveys and Personal Information:</h3>
            <p>
              Highways England occasionally operates electronic surveys on our
              web site, sometimes in conjunction with our contractors. The
              information you provide will be kept in a secure environment only
              accessible by Highways England and the specific contractor(s)
              working with us on that project.
            </p>
            <p>
              The information you submit will only be used for the purpose
              specified in the survey. Personal details are collected only to
              ensure entries are not duplicated and in order to contact
              respondents and any potential prize winners if necessary. All
              personal details will be deleted at the end of the survey analysis
              period unless otherwise stated.
            </p>
            <p>
              Your personal information will not be shared with any other
              individuals or organisations unless otherwise stated.
            </p>
            <h3>Disclaimer:</h3>
            <p>
              The Highways England web site and material relating to Government
              information, products and services (or to third party information,
              products and services), is provided 'as is', without any
              representation or endorsement made and without warranty of any
              kind whether express or implied, including but not limited to the
              implied warranties of satisfactory quality, fitness for a
              particular purpose, non-infringement, compatibility, security and
              accuracy.
            </p>
            <p>
              We do not warrant that the functions contained in the material
              contained in this site will be uninterrupted or error free, that
              defects will be corrected, or that this site or the server that
              makes it available are free of viruses or represent the full
              functionality, accuracy, reliability of the materials. In no event
              will we be liable for any loss or damage including, without
              limitation, indirect or consequential loss or damage, or any loss
              or damages whatsoever arising from use or loss of use of, data or
              profits arising out of or in connection with the use of the
              Highways England web site
            </p>
            <p>
              These Terms and Conditions shall be governed by and construed in
              accordance with the laws of England and Wales. Any dispute arising
              under these Terms and Conditions shall be subject to the exclusive
              jurisdiction of the courts of England and Wales
            </p>
            <h3>External Links</h3>
            <p>
              The Highways England web site and material relating to Government
              information, products and services (or to third party information,
              products and services), is known 'as is', without any
              representation or endorsement made and without warranty of any
              kind whether express or implied, including but not limited to the
              limited warranties of satisfactory quality, fitness for a
              particular purpose, non-infringement, compatibility, security and
              accuracy
            </p>
            <p>© Crown copyright, 2012</p>
            <p>
              You may use and re-use the information featured on this web site
              (not including logos) free of charge in any format or medium,
              under the terms of the Open Government Licence.
            </p>
            <p>
              We encourage users to establish hypertext links to this web site.
            </p>
            <p>
              Any enquiries regarding the use and re-use of this information
              resource should be sent to our email information line:{' '}
              <a href="javascript:avoid">info@highwaysengland.co.uk.</a>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default privacyNotice;
